/**
 * The two visual rules every view shares, kept out of the component files so that a fast
 * refresh of a chip does not remount a whole grid (oxlint's `only-export-components`).
 */
import type { CalendarEvent, EventCategory } from '@/api/endpoints/calendar';

/** The neutral default a category-less event renders with (`080-calendar.md` §6). */
export const NEUTRAL_COLOR = 'var(--muted-foreground)';

export function categoryColor(category: EventCategory | null): string {
  return category?.color ?? NEUTRAL_COLOR;
}

export function isDone(event: CalendarEvent): boolean {
  return event.status === 'done';
}

/** Struck through and dimmed — not hidden, not moved (`080` §3). */
export function doneClass(event: CalendarEvent): string {
  return isDone(event) ? 'line-through opacity-55' : '';
}
